"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import $ from "jquery";
import classNames from "classnames";
import AnnotationCanvas from "../annotation/annotation_canvas";
import Api from "../../api/api";
import pageHelper from "../../helpers/document_pages";
import PageTextHighlighter from "./page_text_highlighter";
import RegionOverlay from "./region_overlay";
import Reskin from "../../helpers/reskin";
const showRawImage = (props) => props.annotating || props.justSaved;
function imageUrl(props, forceRaw) {
  return pageHelper.url(props.page, forceRaw || showRawImage(props));
}
function regionOverlay(props, state) {
  var _a;
  if (!((_a = props.regions) == null ? void 0 : _a.length) || !state.imageWidth || !state.imageHeight) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    RegionOverlay,
    {
      regions: props.regions,
      imageWidth: state.imageWidth,
      imageHeight: state.imageHeight,
      onRegionResize: props.onRegionResize
    }
  );
}
function image(props, state, onLoad) {
  const classes = classNames({
    "document-browser__zoomable-container": true,
    "document-browser__zoomable-container--zoomed": isZoomed(props)
  });
  return /* @__PURE__ */ jsx(
    "img",
    {
      ref: "image",
      width: imageSize(props, state).width,
      height: imageSize(props, state).height,
      className: classes,
      style: __spreadValues(__spreadValues({}, calculateStyle(props, state)), toneFilterStyle(props)),
      src: imageUrl(props),
      crossOrigin: "anonymous",
      onLoad
    }
  );
}
function toneFilterId(props) {
  return `tone-adjustments-${props.page.id}`;
}
function previewedToneAdjustments(props) {
  if (props.disableAnnotations || !showRawImage(props) || !props.toneAdjustments || !Api.Account.currentSettings().tone_adjustments_enabled) {
    return null;
  }
  const values = {
    sharpen: Number(props.toneAdjustments.sharpen) || 0,
    contrast: Number(props.toneAdjustments.contrast) || 0,
    brightness: Number(props.toneAdjustments.brightness) || 0,
    despeckle: Number(props.toneAdjustments.despeckle) || 0
  };
  return _.some(_.values(values)) ? values : null;
}
function toneFilterStyle(props) {
  return previewedToneAdjustments(props) ? { filter: `url(#${toneFilterId(props)})` } : {};
}
function linearTransfer(slope, intercept) {
  const funcs = ["R", "G", "B"].map(
    (channel) => `<feFunc${channel} type="linear" slope="${slope}" intercept="${intercept}"/>`
  );
  return `<feComponentTransfer>${funcs.join("")}</feComponentTransfer>`;
}
function toneFilter(props, state) {
  const values = previewedToneAdjustments(props);
  if (!values) {
    return null;
  }
  const steps = [];
  if (values.sharpen) {
    const a = values.sharpen / 100;
    steps.push(
      `<feConvolveMatrix order="3" kernelMatrix="0 ${-a} 0 ${-a} ${4 * a + 1} ${-a} 0 ${-a} 0" edgeMode="duplicate" preserveAlpha="true"/>`
    );
  }
  if (values.contrast) {
    const slope = __pow((values.contrast + 100) / 100, 2);
    steps.push(linearTransfer(slope, 0.5 - 0.5 * slope));
  }
  if (values.brightness) {
    steps.push(linearTransfer(1, values.brightness / 100));
  }
  if (values.despeckle) {
    const scale = state.imageNaturalWidth ? imageSize(props, state).width / state.imageNaturalWidth : 1;
    steps.push(
      `<feGaussianBlur stdDeviation="${values.despeckle / 2 * scale}"/>`
    );
  }
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "0",
      height: "0",
      style: { position: "absolute" },
      dangerouslySetInnerHTML: {
        __html: `<filter id="${toneFilterId(props)}" color-interpolation-filters="sRGB">${steps.join("")}</filter>`
      }
    }
  );
}
function annotations(props, state) {
  if (props.disableAnnotations || !props.annotating && !props.justSaved) {
    return;
  }
  const settings = Api.Account.currentSettings();
  if (settings.document_annotation_enabled && state.imageWidth && state.imageHeight) {
    const width = imageSize(props, state).width;
    const height = imageSize(props, state).height;
    const style = {
      width,
      height,
      position: "absolute",
      zIndex: props.annotating ? 999 : 9,
      top: 0,
      left: 0
    };
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: "document-browser__zoomable-container__annotations",
        style,
        children: /* @__PURE__ */ jsx(
          AnnotationCanvas,
          {
            width,
            height,
            page: props.page,
            annotating: props.annotating,
            cropping: props.cropping,
            annotationStampUrl: props.annotationStampUrl
          }
        )
      }
    );
  }
}
function imageSize(props, state) {
  return {
    width: props.zoomLevel * (state.imageWidth || 0),
    height: props.zoomLevel * (state.imageHeight || 0)
  };
}
function pageTextHighlighter(props, state) {
  return /* @__PURE__ */ jsx(
    PageTextHighlighter,
    {
      lines: props.page.lines,
      imageHeight: state.imageHeight,
      imageWidth: state.imageWidth,
      textToHighlight: props.textToHighlight
    }
  );
}
function calculateStyle(props, state) {
  if (state.imageHeight) {
    const width = imageSize(props, state).width;
    const height = imageSize(props, state).height;
    return {
      maxWidth: 1e4,
      maxHeight: 1e4,
      width: `${width}px`,
      height: `${height}px`
    };
  }
  return {
    height: "auto",
    width: "auto",
    maxWidth: "100%",
    maxHeight: "none"
  };
}
function isZoomed(props) {
  return props.zoomLevel > 1;
}
class ZoomableImage extends React.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {});
    __publicField(this, "previousImageHeight");
    // STATE
    __publicField(this, "recordNaturalSize", (event) => {
      const img = event.currentTarget;
      this.setState({
        imageNaturalWidth: img.naturalWidth,
        imageNaturalHeight: img.naturalHeight
      });
    });
  }
  // LIFECYCLE
  componentDidMount() {
    this.enableDragScroll();
    this.updateSizing();
  }
  componentWillUnmount() {
    this.disableDragScroll();
  }
  componentDidUpdate() {
    this.updateSizing();
  }
  componentWillReceiveProps(newProps) {
    if (this.props.page.id !== newProps.page.id || this.props.browserExpanded !== newProps.browserExpanded) {
      this.previousImageHeight = void 0;
      this.updateSizing();
    }
  }
  updateSizing() {
    if (_.isEmpty(this.props.page)) {
      return;
    }
    const container = ReactDOM.findDOMNode(this.refs.container);
    const reskinEnabled = Reskin.getVals().indexAudit;
    const containerWidth = reskinEnabled ? $(container).prop("clientWidth") : $(container).innerWidth();
    const { attachment_height, attachment_width } = this.props.page;
    const [sourceWidth, sourceHeight] = attachment_height && attachment_width ? [attachment_width, attachment_height] : [this.state.imageNaturalWidth, this.state.imageNaturalHeight];
    if (!sourceHeight || !sourceWidth) {
      return;
    }
    const calculatedHeight = Math.round(
      containerWidth / sourceWidth * sourceHeight
    );
    if (calculatedHeight === this.previousImageHeight) {
      return;
    }
    if (this.props.zoomLevel === 1 && calculatedHeight !== this.state.imageHeight) {
      this.previousImageHeight = this.state.imageHeight;
      this.setState({
        imageHeight: calculatedHeight,
        imageWidth: containerWidth
      });
    }
  }
  render() {
    const text = this.props.dragAndDropEnabled ? pageTextHighlighter(this.props, this.state) : null;
    return /* @__PURE__ */ jsxs("div", { "data-component": "ZoomableImage", className: "document-browser__zoomable-container", ref: "container", children: [
      annotations(this.props, this.state),
      text,
      regionOverlay(this.props, this.state),
      toneFilter(this.props, this.state),
      image(this.props, this.state, this.recordNaturalSize)
    ] });
  }
  enableDragScroll() {
    const el = ReactDOM.findDOMNode(this.refs.image);
    let lastClientX;
    let lastClientY;
    let pushed;
    const scroller = ReactDOM.findDOMNode(this.refs.container);
    el.md = function(e) {
      pushed = 1;
      lastClientX = e.clientX;
      lastClientY = e.clientY;
      e.preventDefault();
      e.stopPropagation();
    };
    el.mu = function() {
      pushed = 0;
    };
    el.mm = function(e) {
      if (pushed) {
        scroller.scrollLeft -= -lastClientX + (lastClientX = e.clientX);
        scroller.scrollTop -= -lastClientY + (lastClientY = e.clientY);
      }
    };
    el.rs = function(scaleFactor) {
      el.mm({
        clientX: lastClientX * scaleFactor,
        clientY: lastClientY * scaleFactor
      });
    };
    el.addEventListener("mousedown", el.md, true);
    window.addEventListener("mouseup", el.mu, false);
    window.addEventListener("mousemove", el.mm, false);
  }
  disableDragScroll() {
    const el = ReactDOM.findDOMNode(this.refs.image);
    el.removeEventListener("mousedown", el.md);
    window.removeEventListener("mouseup", el.mu);
    window.removeEventListener("mousemove", el.mm);
  }
}
export default ZoomableImage;
